export default __webpack_public_path__ + "static/pageEndCharacter-3485d204ed2fd9c83711891060f468a0.png";